import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm } from 'redux-form';
import Modal from './../../../../../../components/modal';
import WizardButtons from '../../../../../../components/wizard/navigator/buttons';
import { FormattedMessage } from 'react-intl';
import { witnessReject } from '../../../../../../reducers/onboarding';
import messages from '../../../../../../text/messages';

class RejectDocumentDialog extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};

        this.submit = this.submit.bind(this);
    }

    submit() {
        const { witnessReject, role, onSubmit, onClose } = this.props;
        witnessReject(role, () => {
            onClose();
            if (onSubmit) {
                onSubmit({ branch: 'witness_rejected' });
            }
        });
    }

    render() {
        const { modal, onClose, handleSubmit, submitting } = this.props;

        return (
            <Modal open={modal.open} onClose={onClose} managedClose size="col-xs-12 col-sm-6 col-sm-offset-3 witness-reject-dialog">
                <form onSubmit={handleSubmit(values => this.submit(values))}>
                    <div className="row">
                        <div className="col-xs-12 text-center">
                            <FormattedMessage {...messages.confirmation} tagName={'h4'} />
                        </div>
                    </div>
                    <WizardButtons
                        disabled={submitting}
                        back={{ action: onClose, message: <FormattedMessage {...messages.cancel} /> }}
                        submit={{ message: <FormattedMessage id={'verify.documentMismatch'} defaultMessage={'Document does not match'} /> }}
                    />
                </form>
            </Modal>
        );
    }
}

RejectDocumentDialog.defaultProps = {
    modal: undefined,
    onClose: undefined,
    onSubmit: undefined
};
RejectDocumentDialog.propTypes = {
    modal: PropTypes.object.isRequired,
    onClose: PropTypes.func.isRequired,
    onSubmit: PropTypes.func
};

RejectDocumentDialog = reduxForm({
    form: 'witness-onboarding-reject-dialog',
    destroyOnUnmount: false,
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
    forceUnregisterOnUnmount: false
})(RejectDocumentDialog);

const mapStateToProps = state => {
    return {
        role: state.identity.role
    };
};

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            witnessReject
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(RejectDocumentDialog);



// WEBPACK FOOTER //
// ./src/pages/onboarding/tenants/witness/steps/dialogs/rejectDocument.jsx